import React from 'react';
import PropTypes from 'prop-types';
require('core-js/fn/array/find');

import Main from '../components/Main';
import Article from '../components/Main/Article';
import Search from '../components/Search';

const SearchPage = props => {
  const { data } = props;

  return (
    <Main>
      <Article>
        <Search algolia={data.site.siteMetadata.algolia} />
      </Article>
    </Main>
  );
};

SearchPage.propTypes = {
  data: PropTypes.object.isRequired
};

export default SearchPage;

//eslint-disable-next-line no-undef
export const query = graphql`
  query AlgoliaQuery {
    site {
      siteMetadata {
        algolia {
          appId
          searchOnlyApiKey
          indexName
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/search.js